import { render, staticRenderFns } from "./ProductPriority.vue?vue&type=template&id=72370568&"
import script from "./ProductPriority.vue?vue&type=script&lang=ts&"
export * from "./ProductPriority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports